.row {
  // margin: 20px 0;
  gap: 10px;
  display: flex;
  justify-content: space-between;
}